<template>
	<div class="link-list">
		<ul>
			<li class="header" rel="nofollow">
				{{ getConstants('COOPERATION_ECOLOGY') }}
			</li>
			<li class="link">
				<a href="/static/others/partner/partner_list.html" target="_blank">{{
					getConstants('SEO')
				}}</a>
			</li>
			<li class="link">
				<a href="/s/enterprise/partners" target="_blank">{{
					getConstants('CHANNEL_PARTNERS')
				}}</a>
			</li>
			<li class="link reports" @click="troggleReport" id="reports">
				<a href="javascript:void(0)" rel="nofollow">{{
					getConstants('LANDING_NUTSTORE_MEDIA_REPORTS')
				}}</a>
				<div v-show="reportShow" class="reports-links" id="reports_links">
					<div class="links-row">
						<a
							href="https://36kr.com/p/5126604.html"
							target="_blank"
							rel="nofollow"
							:title="getConstants('LANDING_REPORTS_1_TITLE')"
						>
							<span>{{ getConstants('LANDING_REPORTS_1') }}</span>
						</a>
						<a
							href="https://tech.huanqiu.com/news/2018-03/11698936.html"
							target="_blank"
							rel="nofollow"
							:title="getConstants('LANDING_REPORTS_2_TITLE')"
						>
							<span>{{ getConstants('LANDING_REPORTS_2') }}</span>
						</a>
						<a
							href="https://www.ifanr.com/app/991892"
							target="_blank"
							rel="nofollow"
							:title="getConstants('LANDING_REPORTS_3_TITLE')"
						>
							<span>{{ getConstants('LANDING_REPORTS_3') }}</span>
						</a>
						<a
							href="https://sspai.com/post/40457"
							target="_blank"
							rel="nofollow"
							:title="getConstants('LANDING_REPORTS_4_TITLE')"
						>
							<span>{{ getConstants('LANDING_REPORTS_4') }}</span>
						</a>
						<a
							href="https://www.dgtle.com/article-838349-1.html"
							target="_blank"
							rel="nofollow"
							:title="getConstants('LANDING_REPORTS_5_TITLE')"
						>
							<span>{{ getConstants('LANDING_REPORTS_5') }}</span>
						</a>
						<a
							href="https://www.sohu.com/a/230258962_602994"
							target="_blank"
							rel="nofollow"
							:title="getConstants('LANDING_REPORTS_6_TITLE')"
						>
							<span>{{ getConstants('LANDING_REPORTS_6') }}</span>
						</a>
						<a
							href="https://tech.qq.com/a/20180626/035228.htm"
							target="_blank"
							rel="nofollow"
							:title="getConstants('LANDING_REPORTS_7_TITLE')"
						>
							<span>{{ getConstants('LANDING_REPORTS_7') }}</span>
						</a>
						<a
							href="https://tech.chinadaily.com.cn/2018-08/06/content_36716430.htm"
							target="_blank"
							rel="nofollow"
							:title="getConstants('LANDING_REPORTS_8_TITLE')"
						>
							<span>{{ getConstants('LANDING_REPORTS_8') }}</span>
						</a>
					</div>
				</div>
			</li>
			<li class="link">
				<a href="http://www.jianguoyun.com/s/content/?page_id=1575">{{
					getConstants('LANDING_NUTSTORE_BLOGROLL')
				}}</a>
			</li>
			<li class="link hot-links" @click="troggleSeo" id="hot_links">
				<a href="javascript:void(0)" rel="nofollow">{{
					getConstants('POPULAR_TAGS')
				}}</a>
				<div v-show="seoShow" class="SEO-links" id="SEO_links">
					<div class="keywords">
						<div class="links-title">{{ getConstants('KEYWORD') }}</div>
						<div class="links-row">
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1649"
								:title="getConstants('LANDING_SEO_KEYWORD_1_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_1') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1649"
								:title="getConstants('LANDING_SEO_KEYWORD_2_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_2') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1649"
								:title="getConstants('LANDING_SEO_KEYWORD_3_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_3') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1302"
								:title="getConstants('LANDING_SEO_KEYWORD_4_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_4') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1576"
								:title="getConstants('LANDING_SEO_KEYWORD_5_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_5') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1601"
								:title="getConstants('LANDING_SEO_KEYWORD_6_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_6') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1654"
								:title="getConstants('LANDING_SEO_KEYWORD_7_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_7') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1453"
								:title="getConstants('LANDING_SEO_KEYWORD_8_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_8') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1605"
								:title="getConstants('LANDING_SEO_KEYWORD_9_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_9') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1612"
								:title="getConstants('LANDING_SEO_KEYWORD_10_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_10') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1635"
								:title="getConstants('LANDING_SEO_KEYWORD_11_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_11') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1652"
								:title="getConstants('LANDING_SEO_KEYWORD_12_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_12') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1599"
								:title="getConstants('LANDING_SEO_KEYWORD_13_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_13') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1652"
								:title="getConstants('LANDING_SEO_KEYWORD_14_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_14') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1592"
								:title="getConstants('LANDING_SEO_KEYWORD_15_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_15') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1585"
								:title="getConstants('LANDING_SEO_KEYWORD_16_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_16') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1302"
								:title="getConstants('LANDING_SEO_KEYWORD_17_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_17') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1630"
								:title="getConstants('LANDING_SEO_KEYWORD_18_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_18') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1630"
								:title="getConstants('LANDING_SEO_KEYWORD_19_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_19') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1608"
								:title="getConstants('LANDING_SEO_KEYWORD_20_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_20') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1632"
								:title="getConstants('LANDING_SEO_KEYWORD_21_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_21') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1617"
								:title="getConstants('LANDING_SEO_KEYWORD_22_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_22') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1623"
								:title="getConstants('LANDING_SEO_KEYWORD_23_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_23') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1608"
								:title="getConstants('LANDING_SEO_KEYWORD_24_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_24') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1610"
								:title="getConstants('LANDING_SEO_KEYWORD_25_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_25') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1625"
								:title="getConstants('LANDING_SEO_KEYWORD_26_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_26') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1625"
								:title="getConstants('LANDING_SEO_KEYWORD_27_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_27') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1630"
								:title="getConstants('LANDING_SEO_KEYWORD_28_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_28') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1617"
								:title="getConstants('LANDING_SEO_KEYWORD_29_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_29') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1628"
								:title="getConstants('LANDING_SEO_KEYWORD_30_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_30') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1643"
								:title="getConstants('LANDING_SEO_KEYWORD_31_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_31') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1617"
								:title="getConstants('LANDING_SEO_KEYWORD_32_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_32') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1628"
								:title="getConstants('LANDING_SEO_KEYWORD_33_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_33') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1628"
								:title="getConstants('LANDING_SEO_KEYWORD_34_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_34') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1641"
								:title="getConstants('LANDING_SEO_KEYWORD_35_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_35') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1620"
								:title="getConstants('LANDING_SEO_KEYWORD_36_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_36') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1605"
								:title="getConstants('LANDING_SEO_KEYWORD_37_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_37') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1605"
								:title="getConstants('LANDING_SEO_KEYWORD_38_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_38') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1578"
								:title="getConstants('LANDING_SEO_KEYWORD_39_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_39') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1643"
								:title="getConstants('LANDING_SEO_KEYWORD_40_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_40') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1656"
								:title="getConstants('LANDING_SEO_KEYWORD_41_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_41') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1603"
								:title="getConstants('LANDING_SEO_KEYWORD_42_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_42') }}</span>
							</a>
							<a
								href="http://www.jianguoyun.com/s/blog/?p=1582"
								:title="getConstants('LANDING_SEO_KEYWORD_43_TITLE')"
								target="_blank"
							>
								<span>{{ getConstants('LANDING_SEO_KEYWORD_43') }}</span>
							</a>
						</div>
					</div>
				</div>
			</li>
		</ul>
	</div>
</template>
<script>
export default {
	data() {
		return {
			reportShow: false,
			seoShow: false,
		}
	},
	methods: {
		troggleSeo(e) {
			if (e.stopPropagation) {
				e.stopPropagation()
			} else {
				e.cancelBubble = true
			}
			this.seoShow = !this.seoShow
		},
		troggleReport(e) {
			if (e.stopPropagation) {
				e.stopPropagation()
			} else {
				e.cancelBubble = true
			}
			this.reportShow = !this.reportShow
		},
		hideLink() {
			this.reportShow = false
			this.seoShow = false
		},
	},
	mounted() {
		document.body.addEventListener('click', this.hideLink)
	},
	beforeDestroy() {
		document.body.removeEventListener('click', this.hideLink)
	},
}
</script>
